import { render, staticRenderFns } from "./AttactmentTab.vue?vue&type=template&id=69ccfd47&scoped=true&"
import script from "./AttactmentTab.vue?vue&type=script&lang=js&"
export * from "./AttactmentTab.vue?vue&type=script&lang=js&"
import style0 from "./AttactmentTab.vue?vue&type=style&index=0&id=69ccfd47&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ccfd47",
  null
  
)

export default component.exports